export const productsAppDefId = '1380b703-ce81-ff05-f115-39571d94dfcd';
export const searchResultsAppDefId = '1484cb44-49cd-5b39-9681-75188ab429de';
export const searchSuggestionsAppDefId = '49a4ef91-9d6e-43ff-94de-88cb5481cdf5';
